import { render, staticRenderFns } from "./SurchargeModal.vue?vue&type=template&id=1668f233&scoped=true"
import script from "./SurchargeModal.vue?vue&type=script&lang=js"
export * from "./SurchargeModal.vue?vue&type=script&lang=js"
import style0 from "./SurchargeModal.vue?vue&type=style&index=0&id=1668f233&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1668f233",
  null
  
)

export default component.exports